




















import { defineComponent, PropType, computed } from '@vue/composition-api';
import Vue from 'vue';
import CreativeIframeDrawer from '@/components/creative/creative-iframe-drawer/index.vue';

const name = 'ttam-creative-tool-video-editor';

export default defineComponent({
  name,
  components: { CreativeIframeDrawer },
  props: {
    /** iframe 地址 */
    url: { type: String, default: '' },
    /** 当前语言环境 */
    lang: { type: String, default: 'en' },
    /** 是否打开 */
    visible: { type: Boolean, default: false },
    /** 距离顶部距离 */
    marginTop: { type: String },
    /** 初始数据的方法 */
    initDataMethod: {
      type: Function as PropType<() => Promise<Record<string, unknown>>>,
      default: () => () => ({}),
    },
  },
  setup(props, ctx) {
    function commonEmit(eventName: string, data) {
      ctx.emit(eventName, data);
    }

    const _marginTop = computed(() => props.marginTop ?? `${Vue.prototype.$TTAMUI?.headerHeight}px`);

    return {
      commonEmit,
      _marginTop,
    };
  },
});
